/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getActiveState } from '../../../actions/actions';
import { batchMWTSReports } from './mwts.report.utils';

export const generateReport = createAsyncThunk(
	'mwtsReport/generateReport',
	async (params, { getState }) => {
		const { selected, searches, approval } = getActiveState(getState());
		const {
			assetViewMain: { listTotal: { value = 10000 } = {} }
		} = getState();

		const loops = Math.ceil(value / 10000);

		const batches = [];
		for (let i = 0; i < loops; i += 1) {
			batches.push(
				batchMWTSReports(i, selected, approval, searches).then(res => {
					console.log(`batch ${i} done`, res.message);
					return res.message;
				})
			);
		}
		const res = await Promise.all(batches);
		return res;
	}
);
